module.exports = __webpack_public_path__ + "img/134.fff8a07d.jpg";